import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Paper,
} from "@material-ui/core";
import axios from "axios";
import React, { useMemo, useState } from "react";
import { toast } from "react-toastify";
import GameTypes from "../../common/GameTypes";
import Sports from "../../common/Sports";
import WagerLimitsList from "../wagerLimitsComponents/WagerLimitsList";
import "./ApplyAll.css";

function ApplyAll({
  className = "",
  classNameButton = "",
  title,
  buttonText,
  params: { ChangeType, IdSport, Param1, Param2, Param3 },
}) {
  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );
  const [selectedProfileLimits, setSelectedProfileLimits] = useState([]);
  const [selectedGameTypes, setSelectedGameTypes] = useState([]);
  const [selectedSports, setSelectedSports] = useState([]);
  const [localOptionsState, setLocalOptionsState] = useState({});
  const [onlineOptionsState, setOnlineOptionsState] = useState({});
  const [open, setOpen] = useState(false);

  const localOptions = [
    "Side",
    "Total",
    "Money Line",
    "Parlays",
    "Teasers",
    "If Bets",
    "Reverses",
    "Related",
  ];
  const onlineOptions = [
    "Side",
    "Total",
    "Money Line",
    "Parlays",
    "Teasers",
    "If Bets",
    "Reverses",
    "Related",
  ];

  const setGameTypeOnMem = (idGameType) => {
    setSelectedGameTypes((prev) => [...new Set([...prev, idGameType])]);
  };

  const setProfileLimitOnMem = (idProfileLimit) => {
    setSelectedProfileLimits((prev) => [...new Set([...prev, idProfileLimit])]);
  };

  const onSportChanged = (sport) => {
    setSelectedSports((prev) => [...new Set([...prev, sport])]);
  };

  const handleLocalOptionChange = (event) => {
    setLocalOptionsState({
      ...localOptionsState,
      [event.target.name]: event.target.checked,
    });
  };

  const handleOnlineOptionChange = (event) => {
    setOnlineOptionsState({
      ...onlineOptionsState,
      [event.target.name]: event.target.checked,
    });
  };

  const generateProfileObjects = () => {
    const result = [];
    const commonProperties = {
      IdProfileLimitsFrom: Param1,
    };

    selectedProfileLimits.forEach((profileId) => {
      selectedGameTypes.forEach((gameTypeId) => {
        selectedSports.forEach((sportId) => {
          // Local options
          const localObject = {
            IdProfileLimits: profileId,
            IdGameType: gameTypeId,
            IdSport: sportId,
            Online: 0,
            ChangeSide: localOptionsState["Side"] || false,
            Side: localOptionsState["Side"] ? 2.5 : 0,
            ChangeTotal: localOptionsState["Total"] || false,
            Total: localOptionsState["Total"] ? 150 : 0,
            ChangeMoneyLine: localOptionsState["Money Line"] || false,
            MoneyLine: localOptionsState["Money Line"] ? 1.75 : 0,
            ChangeParlays: localOptionsState["Parlays"] || false,
            Parlays: localOptionsState["Parlays"] ? 5.0 : 0,
            ChangeTeasers: localOptionsState["Teasers"] || false,
            Teasers: localOptionsState["Teasers"] ? 3.0 : 0,
            ChangeIfBets: localOptionsState["If Bets"] || false,
            IfBets: localOptionsState["If Bets"] ? 10.0 : 0,
            ChangeReverses: localOptionsState["Reverses"] || false,
            Reverses: localOptionsState["Reverses"] ? 2.0 : 0,
            ChangeRelated: localOptionsState["Related"] || false,
            Related: localOptionsState["Related"] ? 1.5 : 0,
            IdUser: userInfo.IdUser,
          };
          result.push(localObject);

          // Online options
          const onlineObject = {
            IdProfileLimits: profileId,
            IdGameType: gameTypeId,
            IdSport: sportId,
            Online: 1,
            ChangeSide: onlineOptionsState["Side"] || false,
            Side: onlineOptionsState["Side"] ? 2.5 : 0,
            ChangeTotal: onlineOptionsState["Total"] || false,
            Total: onlineOptionsState["Total"] ? 150 : 0,
            ChangeMoneyLine: onlineOptionsState["Money Line"] || false,
            MoneyLine: onlineOptionsState["Money Line"] ? 1.75 : 0,
            ChangeParlays: onlineOptionsState["Parlays"] || false,
            Parlays: onlineOptionsState["Parlays"] ? 5.0 : 0,
            ChangeTeasers: onlineOptionsState["Teasers"] || false,
            Teasers: onlineOptionsState["Teasers"] ? 3.0 : 0,
            ChangeIfBets: onlineOptionsState["If Bets"] || false,
            IfBets: onlineOptionsState["If Bets"] ? 10.0 : 0,
            ChangeReverses: onlineOptionsState["Reverses"] || false,
            Reverses: onlineOptionsState["Reverses"] ? 2.0 : 0,
            ChangeRelated: onlineOptionsState["Related"] || false,
            Related: onlineOptionsState["Related"] ? 1.5 : 0,
            IdUser: userInfo.IdUser,
          };
          result.push(onlineObject);
        });
      });
    });

    return {
      IdProfileLimitsFrom: Param1,
      ProfileLimits: result,
    };
  };

  const handleSubmit = () => {
    const submissionData = generateProfileObjects();
    console.log("Submission Data:", submissionData);
    const url =
      process.env.REACT_APP_API2_URL +
      "/Profile/PlayerProfileLimitsDetails_UpdateByFields";
    axios({
      method: "post",
      url: url,
      data: submissionData,
    }).then((response) => {
      if (response.data === -1) {
        toast.error("error");
      } else {
        toast.success("data updated");
      }
    });
  };

  return (
    <>
      <Button
        className={`${classNameButton} btn btn-primary`}
        variant="contained"
        onClick={() => setOpen(true)}
      >
        {buttonText ? buttonText : "Last Changes"}
      </Button>
      <Dialog open={open} fullWidth>
        <DialogContent>
          <div id="main-div" className={`${className} container-fluid`}>
            <Paper className="p-3">
              <h2 className="text-center">{title}</h2>
              <div className="row">
                <div className="col-md-3">
                  <h3>Profile</h3>
                  <WagerLimitsList
                    showLoading={false}
                    setWagerLimit={setProfileLimitOnMem}
                    enableRowSelection={true}
                  />
                </div>
                <div className="col-md-3">
                  <h3>Game Types</h3>
                  <GameTypes
                    isEasy={true}
                    setGameTypeOnMem={setGameTypeOnMem}
                    isInput={false}
                    enableRowSelection={true}
                  />
                </div>
                <div className="col-md-3">
                  <h3>Sports</h3>
                  <Sports
                    setIdSportOnMem={onSportChanged}
                    showDataTable={true}
                    enableRowSelection={true}
                    hiddenColumn={true}
                  />
                </div>
                <div className="col-md-3">
                  <h3>Local</h3>
                  <div className="checkbox-group">
                    {localOptions.map((option) => (
                      <div key={option} className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={option}
                          name={option}
                          checked={localOptionsState[option] || false}
                          onChange={handleLocalOptionChange}
                        />
                        <label className="form-check-label" htmlFor={option}>
                          {option}
                        </label>
                      </div>
                    ))}
                  </div>
                  <h3>Online</h3>
                  <div className="checkbox-group">
                    {onlineOptions.map((option) => (
                      <div key={option} className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={option}
                          name={option}
                          checked={onlineOptionsState[option] || false}
                          onChange={handleOnlineOptionChange}
                        />
                        <label className="form-check-label" htmlFor={option}>
                          {option}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </Paper>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            className="btn btn-primary"
            onClick={() => {
              handleSubmit();
              /*setOpen(false);*/
            }}
          >
            Apply
          </Button>
          <Button
            variant="contained"
            className="btn btn-secondary"
            onClick={() => setOpen(false)}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ApplyAll;
